<!--sidebar-->
<c-sidebar
  #sidebar1="cSidebar"
  class="d-print-none sidebar sidebar-fixed border-end"
  colorScheme="dark"
  id="sidebar1"
  visible
  >
  <c-sidebar-header class="border-bottom">
    <c-sidebar-brand [routerLink]="[]">
      <img [src]="'assets/brand/application-logo-' + applicationsService.applicationIdSelected + '.png'">
      <span class="ms-2">{{ applicationsService.applications.find(a => a.id === applicationsService.applicationIdSelected)?.name }}</span>
    </c-sidebar-brand>
  </c-sidebar-header>

  <ng-scrollbar class="overflow" pointerEventsMethod="scrollbar" visibility="hover">
    <c-sidebar-nav #overflow [navItems]="navItems" dropdownMode="close" compact />
  </ng-scrollbar>
</c-sidebar>

<!--main-->
<div class="wrapper d-flex flex-column min-vh-100">
  <!--app-header-->
  <app-default-header
    [cShadowOnScroll]="'sm'"
    class="mb-4 d-print-none header header-sticky p-0 shadow-sm"
    position="sticky"
    sidebarId="sidebar1"
    />
    <!--app-body-->
    <div class="body flex-grow-1">
      <c-container breakpoint="lg" class="h-auto px-4">
        @for (alert of alerts; track alert) {
          <div>
            <c-alert [color]="alert.type" dismissible fade>{{ alert.message }}</c-alert>
          </div>
        }

        <router-outlet />
      </c-container>
    </div>
    <!--app footer-->
    <app-default-footer />
  </div>
